import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect, memo} from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import SwiperCore, {Autoplay} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import HomepageTVChannelsListBlockData from 'Models/Content/HomepageTVChannelsListBlockData';
import 'swiper/swiper.scss';
import HiddenStopAndStartButton from 'app/utilities/HiddenStopAndStartButton';
import TVChannelItemBlockData from 'Models/Content/TVChannelItemBlockData';
import {getImageProps, ImageProps} from 'app/utilities/ImageProps';

SwiperCore.use([Autoplay]);

const TRANSITION_TIME = 450;

type sliders = {
  name: string;
  image: ImageProps;
};

const HomepageTVChannelsListBlock = ({data, context}: ComponentProps<HomepageTVChannelsListBlockData>) => {
  const sliders: sliders[] = data.items.expandedValue.map((item: TVChannelItemBlockData) => ({
    name: item.title.value,
    image: getImageProps(item.image, context),
  }));

  const [swiperInstence, setSwiperInstence] = useState<SwiperCore>(null);
  const [swiperIsStop, setSwiperIsStop] = useState<Boolean>(false);
  const [swiperAutoPlay, setSwiperAutoPlay] = useState('Stop');

  useEffect(() => {
    if (swiperIsStop) {
      swiperInstence?.autoplay.stop();
      setSwiperAutoPlay('Start');
    } else {
      swiperInstence?.autoplay.start();
      setSwiperAutoPlay('Stop');
    }
  }, [swiperIsStop, swiperInstence]);

  return (
    <div className={`HomepageTVChannelsListBlock`} style={{transitionDuration: `${TRANSITION_TIME}ms`}}>
      <Swiper
        onSwiper={(swiper) => {
          setSwiperInstence(swiper);
        }}
        className={`HomepageTVChannelsListBlock__swiper`}
        autoplay={{delay: 0, disableOnInteraction: false, waitForTransition: false}}
        slidesPerView='auto'
        speed={4000}
        centeredSlides
        loop
        loopedSlides={sliders.length}
        >
        {sliders.map((item, i) => (
          <SwiperSlide key={i} className={`HomepageTVChannelsListBlock__slide`}>
            <div className='HomepageTVChannelsListBlock__card'>
              <Image {...item.image} alt='תמונות של ערוצים' className='HomepageTVChannelsListBlock__image' />
            </div>
            <p className='HomepageTVChannelsListBlock__title'>{item.name}</p>
          </SwiperSlide>
        ))}

        <HiddenStopAndStartButton className='' onClick={() => setSwiperIsStop((prevState) => !prevState)} swiperAutoPlay={swiperAutoPlay} />
      </Swiper>
    </div>
  );
};

export default memo(HomepageTVChannelsListBlock);
